<template>
    <div v-bind:class="readAccessClasses">

        <div class="na-list">
            <DxDataGrid v-model:data-source="listList"
                        :activeStateEnabled="true"
                        :allowColumnReordering="true"
                        :allowColumnResizing="true"
                        :rowAlternationEnabled="true"
                        @saving="onSaving"
                        @exporting="onExporting"
                        :show-borders="true">
                <DxEditing mode="batch"
                           :allow-updating="true"
                           :allow-adding="true"
                           :allow-deleting="true"
                           startEditAction="click" />
                <DxColumnChooser :enabled="true" />
                <DxColumnFixing :enabled="true" />
                <DxFilterPanel :visible="true" />
                <DxFilterRow :visible="true" />
                <DxHeaderFilter :visible="true" />
                <DxSearchPanel :visible="true" placeholder="Search..." />
                <DxLoadPanel :enabled="true" />
                <DxPaging :page-size="15" />
                <DxPager :visible="true"
                         :allowed-page-sizes="100"
                         :display-mode="full"
                         :show-page-size-selector="true"
                         :show-info="true"
                         :show-navigation-buttons="true" />
                <DxSorting mode="multiple" />
                <DxGroupPanel :visible="true" />
                <DxStateStoring :enabled="false"
                                type="localStorage"
                                storage-key="listList" />
                <DxExport :enabled="true"
                          :allow-export-selected-data="true" />


                <DxColumn caption='ID' data-type="number" data-field='LisId' :allow-editing="false" :width="100" />
                <DxColumn :caption='col.NameCol' name='LisName' data-type='string' data-field='LisName' :allow-editing="true" />
                <DxColumn :caption='col.ActivatedCol' data-type='boolean' data-field='LisEnabled' :allow-editing="true" :width="100" />
                <DxColumn :caption='col.RoundSp' data-type='boolean' data-field='LisIsRoundSpecific' :allow-editing="true" :width="100" />
                <DxColumn :caption='col.NumRecords' data-type='number' data-field='LitCount' :allow-editing="false" :width="100" />
                <DxColumn :caption='col.CreatedBy' data-type='string' data-field='LisCreatedBy' :allow-editing="true" :visible=false :width="100" />
                <DxColumn :caption='col.CreatedOn' data-type='date' data-field='LisCreatedOn' :allow-editing="false" :visible=false :width="100" />
                <DxColumn :caption='col.ChangedBy' data-type='string' data-field='LisChangedBy' :allow-editing="false" :visible=false :width="100" />
                <DxColumn :caption='col.ChangedOn' data-type='date' data-field='LisChangedOn' :allow-editing="false" :visible=false :width="100" />


            </DxDataGrid>
        </div>
    </div>
</template>
<script>
    import {
        DxDataGrid,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxSorting,
        DxPaging,
        DxPager,
        DxColumn,
        DxFilterPanel,
        DxStateStoring,
        DxGroupPanel,
        DxExport,
        DxEditing
    } from 'devextreme-vue/data-grid'
    import $ from "jquery"

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    export default {
        name: 'TopicOverview',
        components: {
            DxDataGrid,
            DxColumnChooser,
            DxColumnFixing,
            DxFilterRow,
            DxHeaderFilter,
            DxSearchPanel,
            DxLoadPanel,
            DxSorting,
            DxPaging,
            DxPager,
            DxFilterPanel,
            DxStateStoring,
            DxColumn,
            DxGroupPanel,
            DxExport,
            DxEditing
        },

        data() {
            return {
                col: {
                    ActivatedCol: this.$LanguageProvider.GetResource("ActivatedCol", "Caption", "Aktiviert"),
                    NameCol: this.$LanguageProvider.GetResource("NameCol", "Caption", "Name"),
                    RoundSp: this.$LanguageProvider.GetResource("RoundSp", "Caption", "Rundenspezifisch"),
                    NumRecords: this.$LanguageProvider.GetResource("NumRecords", "Caption", "Anzahl Einträge"),
                    CreatedBy: this.$LanguageProvider.GetResource("CreatedBy", "Caption", "Erstellt von"),
                    CreatedOn: this.$LanguageProvider.GetResource("CreatedBy", "Caption", "Erstellt am"),
                    ChangedBy: this.$LanguageProvider.GetResource("ChangedBy", "Caption", "Geändert von"),
                    ChangedOn: this.$LanguageProvider.GetResource("ChangedOn", "Caption", "Geändert am"),
                }

            }
        },
        computed: {
            listList() {
                var result = this.$store.state.listStore.listList
                return result
            },
        },
        watch: {
        },
        mounted: function () {
            this.$store.dispatch("getListList", {})
        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            onSaving(e) {
                var updates = e.changes.filter(m => m.type == "update").map(m => {
                    return $.extend(m.key, m.data)
                })
                var remove = e.changes.filter(m => m.type == "remove").map(m => m.key.LisId)
                var insert = e.changes.filter(m => m.type == "insert").map(m => {
                    m.data.key = m.key
                    return m.data
                })
                this.$store.dispatch("saveListList", { updates: updates, remove: remove, insert: insert })

            }
        }
    }
</script>
<style scoped>
</style>